import BaseAPI from "api/BaseAPI";

export default class Category extends BaseAPI {
	
	
	getCategories = async (params) => {
		var promise = await this.init().get("/category", { params: params });
		return promise;
	};
	
}